import * as types from './actiontypes';

export function getSelectTemplateData(url, resource) {
	return {
		type: types.GET_SELECTTEMPLATE,
		meta: {
			api: {
				url,
				method: 'GET',
				data: {
					resource
				}
			}
		}
	};
}
